module.exports = __webpack_public_path__ + "static/media/chatadd.27ca738f.svg";